import React from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2, Mail } from "lucide-react";

import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import SEO from "@/components/shared/SEO";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/context/I18nContext";

export default function ApplicationReceivedPage() {
  const { locale } = useI18n();
  const navigate = useNavigate();
  const L = (en, es) => (locale === "es" ? es : en);

  return (
    <div className="min-h-screen bg-[#FAFAF9] flex flex-col" data-testid="application-received-page">
      <SEO title={L("Application received — Ever Clean Home", "Postulación recibida — Ever Clean Home")} noindex />
      <Header />
      <div className="flex-1 grid place-items-center px-4 md:px-8 py-20">
        <div className="max-w-xl w-full text-center">
          <div className="w-20 h-20 mx-auto rounded-2xl bg-[#0EA5A4]/10 text-[#0F766E] grid place-items-center">
            <CheckCircle2 className="w-10 h-10" />
          </div>
          <h1 className="font-display text-4xl md:text-5xl font-extrabold tracking-tighter mt-6">
            {L("Thanks! 🎉", "¡Gracias! 🎉")}
          </h1>
          <p className="mt-4 text-lg text-[#4B5563]">
            {L("We've received your application. We'll be in touch within 48 hours.",
              "Recibimos tu postulación. Te contactaremos dentro de las próximas 48 horas.")}
          </p>
          <div className="mt-6 inline-flex items-center gap-2 text-sm text-[#4B5563] bg-white border border-[#E5E7EB] rounded-full px-4 py-2">
            <Mail className="w-4 h-4 text-[#0EA5A4]" />
            {L("Check your email for a confirmation.", "Revisa tu email para la confirmación.")}
          </div>
          <div className="mt-8">
            <Button variant="outline" className="rounded-xl" onClick={() => navigate("/")} data-testid="received-home">
              {L("Back to home", "Volver al inicio")}
            </Button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
